/**
 * Initial state
 */
const initialState = {
    reportsData: [],
    submitting:false
};

export default function (state = initialState, action) {
    const {type, payload} = action;

    switch (type) {

        case 'REPORTS_RESET':
            return initialState;
        case 'REPORTS_GET_INPROCESS':{
            return {
                ...state,
                reportsData: [],
                submitting:true
            }
        }
        case 'REPORTS_GET_SUCCESS': {
            return {
                ...state,
                reportsData: payload,
                submitting:false
            }
        }
        case 'REPORTS_GET_FAILURE': {
            return {
                ...state,
                reportsData: [],
                submitting:false
            }
        }
        default:
            break;
    }

    return state
}


// WEBPACK FOOTER //
// ./src/reducers/reports.js